// src/shared/components/ErrorMessage.tsx

import React from 'react';

interface ErrorMessageProps {
  message: string;
  onClose?: () => void;
  type?: 'error' | 'warning' | 'info';
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  onClose, 
  type = 'error' 
}) => {
  const typeClasses = {
    error: 'error-message-error',
    warning: 'error-message-warning',
    info: 'error-message-info'
  };

  const icons = {
    error: '❌',
    warning: '⚠️',
    info: 'ℹ️'
  };

  return (
    <div className={`error-message ${typeClasses[type]}`}>
      <div className="error-content">
        <span className="error-icon">{icons[type]}</span>
        <span className="error-text">{message}</span>
      </div>
      {onClose && (
        <button 
          onClick={onClose}
          className="error-close-btn"
          aria-label="Cerrar mensaje"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;